<template>
    <div>
        <Login/>
        <Registration/>
        <PasswordForgot/>
    </div>
</template>
<script>
    import Login from "./Login";
    import Registration from "./Registration";
    import PasswordForgot from "./PasswordForgot";
    export default {
        name: 'AuthorizationWindow',
        components: {PasswordForgot, Registration, Login},

        mounted() {
            // modals
            $('.window-wrapper .btn-close, .window-wrapper .button-close-window').on('click', function(e){
                // e.preventDefault();
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            });

            $('.form-field-input input').each(function () {
                if ($(this).val() === '') {
                    $(this).closest('.form-field-input').removeClass('filled');
                } else {
                    $(this).closest('.form-field-input').addClass('filled');
                }
            });

            $('.form-field-input input').on('focus keyup', function () {
                $(this).closest('.form-field-input').addClass('filled');
            }).blur(function () {
                if ($(this).val() == '') {
                    $(this).closest('.form-field-input').removeClass('filled');
                }
            });
        }
    }
</script>
